import React from 'react'
import '../../App.css';
import '../Hero/home.css';
import './loading.css'

const Loading = () => {
  return (
    <div className='loading'>
        <span className="loader"></span>
    </div>
  )
}

export default Loading